export default __webpack_public_path__ + "static/media/directions_subwaydirections_transit.d25b4246.svg";